import { createFileRoute } from "@tanstack/react-router";

import { ShareLanding, shareLandingHead } from "../components/ShareLanding";
import { documentHeaders } from "../lib/seo";

/**
 * `/scan/<id>` — the web side of a shared scan result. The referral variant
 * next door explains the arrangement; this one carries the stronger privacy
 * case, since a scan is a photograph of somebody's face and seven numbers
 * scoring it.
 *
 * NOTHING ABOUT THE SCAN IS FETCHED OR RENDERED, and that is the decision
 * rather than an unfinished loader — see `ShareLanding`. The id is in the path
 * so the app receives it; the page itself never resolves it.
 *
 * There is no share-a-scan surface in the app yet. v1's was an image card with
 * the scores burned into it (`recovery/screens/share.png`), which is a
 * different mechanism entirely and left no URL for anyone to open.
 */
export const Route = createFileRoute("/scan/$id")({
  headers: documentHeaders,
  head: () => shareLandingHead("scan"),
  component: () => <ShareLanding kind="scan" />,
});
